import { EnvironmentType, ExceptionCode } from "@/enums/enums";
import { i18n } from "@/i18n";

export function NewObject(obj: any) {
  if (obj == "") {
    return "";
  } else {
    return JSON.parse(JSON.stringify(obj));
  }
}
export function CheckIsDevelop() {
  return process.env.VUE_APP_TYPE_ENV <= EnvironmentType.SIT;
}
export function CheckIsMUZE() {
  return process.env.VUE_APP_Is_MUZE == 1;
}
export function GetMessageExceptionCode(exception: any) {
  let message: any = "";
  switch (exception.code) {
    case ExceptionCode.AssetTemplateCodeDuplicated:
      message = i18n.t("Asset_Group_Code_Already_Been_Used");
      break;
    case ExceptionCode.ImportTransactionExceed:
      message = i18n.t("ImportTransaction_Exceed");
      break;
    case ExceptionCode.LockByPeriod:
      message = i18n.t("Lock_old_entries", { date: exception.content.GetDateFormat() });
      break;
    default:
      message = ExceptionCode
        ? `${i18n.t("Something_Wrong")} Error Code : ${ExceptionCode}`
        : i18n.t("Something_Wrong");
      break;
  }
  return message;
}
export function DecodeJwtResponse(credential: any) {
  return JSON.parse(atob(credential.split(".")[1]).toString());
}

function DetectTabClosing(e: any) {
  const confirmationMessage = "";

  (e || window.event).returnValue = confirmationMessage;
  return confirmationMessage;
}

export function AddDetectTabClosing() {
  window.addEventListener("beforeunload", DetectTabClosing);
}
export function RemoveDetectTabClosing() {
  window.removeEventListener("beforeunload", DetectTabClosing);
}
